import "../assets/index-400b48a6.css";
import { n } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const a = {
  name: "CheckboxMarkedCircleIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var s = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon checkbox-marked-circle-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(r) {
    return t.$emit("click", r);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, c = [], o = /* @__PURE__ */ n(
  a,
  s,
  c,
  !1,
  null,
  null,
  null,
  null
);
const _ = o.exports, u = {
  name: "AlertDecagramIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var d = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon alert-decagram-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(r) {
    return t.$emit("click", r);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M13,17H11V15H13V17M13,13H11V7H13V13Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, f = [], p = /* @__PURE__ */ n(
  u,
  d,
  f,
  !1,
  null,
  null,
  null,
  null
);
const m = p.exports, v = {
  name: "AlertIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var g = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon alert-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(r) {
    return t.$emit("click", r);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, h = [], C = /* @__PURE__ */ n(
  v,
  g,
  h,
  !1,
  null,
  null,
  null,
  null
);
const l = C.exports, L = {
  name: "InformationIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var $ = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon information-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(r) {
    return t.$emit("click", r);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, y = [], w = /* @__PURE__ */ n(
  L,
  $,
  y,
  !1,
  null,
  null,
  null,
  null
);
const k = w.exports;
const A = {
  name: "NcNoteCard",
  props: {
    /**
     * Type of the attribute
     */
    type: {
      type: String,
      default: "warning",
      validator: (i) => ["success", "info", "warning", "error"].includes(i)
    },
    showAlert: {
      type: Boolean,
      default: !1
    },
    heading: {
      type: String,
      default: ""
    }
  },
  computed: {
    shouldShowAlert() {
      return this.showAlert || this.type === "error";
    },
    icon() {
      switch (this.type) {
        case "error":
          return m;
        case "success":
          return _;
        case "info":
          return k;
        case "warning":
          return l;
        default:
          return l;
      }
    },
    color() {
      switch (this.type) {
        case "error":
          return "var(--color-error)";
        case "success":
          return "var(--color-success)";
        case "info":
          return "var(--color-info)";
        case "warning":
          return "var(--color-warning)";
        default:
          return "var(--color-warning)";
      }
    }
  }
};
var b = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "notecard", class: `notecard--${t.type}`, attrs: { role: t.shouldShowAlert ? "alert" : "note" } }, [e(t.icon, { tag: "component", staticClass: "notecard__icon", class: { "notecard__icon--heading": t.heading }, attrs: { "fill-color": t.color } }), e("div", [t.heading ? e("h2", [t._v(" " + t._s(t.heading) + " ")]) : t._e(), t._t("default")], 2)], 1);
}, x = [], z = /* @__PURE__ */ n(
  A,
  b,
  x,
  !1,
  null,
  "3a409988",
  null,
  null
);
const S = z.exports;
export {
  S as default
};
